import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreator from "../../store/actions/index";
import { KeyboardDateTimePicker } from "@material-ui/pickers";
import moment from "moment-timezone";
import "moment/locale/pl";
import { makeStyles, useTheme } from "@material-ui/core";
import { convertMomentEpoch, themeTypeToBool } from "../../utils/helpers";
import t from "../../languages/pl";
import { dateTimePickerFormat, displayDateTimeWithoutSecondsFormat } from '../../utils/staticData';

const useStyles = makeStyles(theme => ({
    input: {
        fontSize: 15,
    },
    datePicker: {
        width: 150,
        margin: theme.spacing(1)
    },
    label: {
        color: themeTypeToBool(theme.palette.type) ? "#000" : "#fff"
    },
    hideAdornment: {
        display: "none"
    }
}));

moment.locale("pl");

const startTimePickerName = "startTime";
const endTimePickerName = "endTime";

function TimePeriodPicker(props) {
    const theme = useTheme();
    const classes = useStyles(theme);
    const { startDate, endDate, disabled, onChange } = props;
    const [isOpen, setOpen] = useState(false);
    const [isToOpen, setToOpen] = useState(false);

    const handleStartDateChange = (e) => {
        let fromEndDate = convertMomentEpoch(endDate).format(dateTimePickerFormat);
        let condition = moment(fromEndDate).isAfter(e);
        if (condition){
            onChange && onChange({ target: { name: startTimePickerName, value: moment(e).unix()}});
        }
        else props.openSnackbarInfo(t.dateCannotBeAfterFinishDateMessage);
    };

    const handleEndDateChange = (e) => {
        let fromStartDate = convertMomentEpoch(startDate).format(dateTimePickerFormat);
        let condition = moment(fromStartDate).isBefore(e);
        let condition2 = e.isBefore(moment());
        if (condition && condition2){
            onChange && onChange({ target: { name: endTimePickerName, value: moment(e).unix()}});
        }
        else if (!condition) {
            props.openSnackbarInfo(t.dateCannotBeBeforeStartDateMessage);
        }
        else if (!condition2) {
            props.openSnackbarInfo(t.dateCannotBeInTheFutureMessage);
        }
    };

    return (
        <React.Fragment>
            <KeyboardDateTimePicker
                disabled={disabled}
                label={t.dateFrom}
                inputVariant="standard"
                className={classes.datePicker}
                InputProps={{ classes: { input: classes.input }}}
                InputLabelProps={{ classes: { root: classes.label } }}
                InputAdornmentProps={{ classes: { root: classes.hideAdornment } }}
                variant="inline"
                size="small"
                ampm={false}
                maxDate={convertMomentEpoch(endDate).format(dateTimePickerFormat)}
                value={convertMomentEpoch(startDate).format(dateTimePickerFormat)}
                name={startTimePickerName}
                onChange={handleStartDateChange}
                disableFuture
                format={displayDateTimeWithoutSecondsFormat}
                open={isOpen && !disabled}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                onClick={() => !disabled && setOpen(true)}
            />
            <KeyboardDateTimePicker
                disabled={disabled}
                label={t.dateTo}
                inputVariant="standard"
                className={classes.datePicker}
                InputProps={{ classes: { input: classes.input } }}
                InputLabelProps={{ classes: { root: classes.label } }}
                InputAdornmentProps={{ classes: { root: classes.hideAdornment } }}
                variant="inline"
                size="small"
                ampm={false}
                minDate={convertMomentEpoch(startDate).format(dateTimePickerFormat)}
                value={convertMomentEpoch(endDate).format(dateTimePickerFormat)}
                name={endTimePickerName}
                onChange={handleEndDateChange}
                disableFuture
                format={displayDateTimeWithoutSecondsFormat}
                open={isToOpen}
                onOpen={() => setToOpen(true)}
                onClose={() => setToOpen(false)}
                onClick={() => !disabled && setToOpen(true)}
            />
        </React.Fragment>
    );
}
const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

export default connect(
    null,
    mapDispatchToProps
)(TimePeriodPicker);

TimePeriodPicker.propTypes = {
    disabled: PropTypes.bool,
    startDate: PropTypes.number,
    endDate: PropTypes.number,
    onChange: PropTypes.func,
    //redux
    openSnackbarInfo: PropTypes.func,
};

TimePeriodPicker.defaultProps = {
    startDate: moment().startOf('week').unix(),
    endDate: moment().endOf('day').unix()
};
